import { Grid, alpha, styled } from '@mui/material';

interface BoxContainerProps {
  isselected: string;
}

const BoxContainer = styled(Grid)<BoxContainerProps>(({ theme, isselected }) => ({
  border:
    isselected === 'true'
      ? `1.5px solid ${theme.palette.primary.main}`
      : `1px solid ${alpha(theme.palette.divider, 0.15)}`,
  borderRadius: '12px',
  width: '100%',
  minHeight: '160px',
  padding: '0',
  cursor: 'pointer',
  background: isselected === 'true' ? alpha(theme.palette.primary.main, 0.03) : theme.palette.background.paper,
  boxShadow:
    isselected === 'true'
      ? `0 0 0 1px ${theme.palette.primary.main}, 0 4px 14px ${alpha(theme.palette.primary.main, 0.1)}`
      : '0 1px 4px rgba(0, 0, 0, 0.03)',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    borderColor: isselected === 'true' ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.4),
    boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.08)}`,
  },
}));

const ScrollableBox = styled(Grid)`
  overflow-y: auto;
  max-height: 520px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
  }
`;

export { BoxContainer, ScrollableBox };
